import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { Problem } from '../types';
interface MultipleChoiceProps {
  problem: Problem;
  onAnswer: (answer: string) => void;
  disabled: boolean;
}
// Helper component to render a fraction vertically in buttons
const FractionButton = ({
  value
}: {
  value: string;
}) => {
  if (!value.includes('/')) {
    return <span data-id="element-151">{value}</span>;
  }
  const [numerator, denominator] = value.split('/');
  return <span className="inline-flex flex-col items-center leading-tight" data-id="element-152">
      <span className="pb-0.5" data-id="element-153">{numerator}</span>
      <span className="border-t-2 border-current pt-0.5 min-w-[2ch]" data-id="element-154">
        {denominator}
      </span>
    </span>;
};
export function MultipleChoice({
  problem,
  onAnswer,
  disabled
}: MultipleChoiceProps) {
  const optionCount = problem.options?.length || 4;
  const gridCols = optionCount === 6 ? 'grid-cols-2 md:grid-cols-3' : 'grid-cols-2';
  return <div className={`grid ${gridCols} gap-4 w-full max-w-md mx-auto`} data-id="element-155">
      {problem.options?.map((option, index) => <motion.div key={`${problem.id}-${index}`} initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: index * 0.05
    }} data-id="element-156">
          <Button variant="outline" size="xl" fullWidth onClick={() => onAnswer(option.toString())} disabled={disabled} className="text-3xl font-semibold hover:border-indigo-500 hover:text-indigo-600 hover:bg-indigo-50 transition-all" data-id="element-157">
            <FractionButton value={option.toString()} data-id="element-158" />
          </Button>
        </motion.div>)}
    </div>;
}